/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import BaseExhibitorTemplate from '@bottlebooks/gatsby-theme-event-pages/src/templates/ExhibitorTemplate';
import { graphql as gatsbyGraphQL } from 'gatsby';
import addPriceRange from '../../../addPriceRange';

export * from '@bottlebooks/gatsby-theme-event-pages/src/templates/ExhibitorTemplate';

export default function ExhibitorTemplate({
  data,
  pageContext,
  location,
  navigate,
}) {
  return (
    <BaseExhibitorTemplate
      data={afterQuery(data)}
      pageContext={pageContext}
      location={location}
      navigate={navigate}
    />
  );
}

export const fragment = gatsbyGraphQL/* GraphQL */ `
  query vv_ExhibitorTemplate(
    $id: String!
    $eventId: ID!
    $exhibitorId: ID!
    $locale: Bottlebooks_ContentLocale
    $previousId: String
    $nextId: String
  ) {
    bottlebooks {
      event(eventId: $eventId, locale: $locale) {
        ...ExhibitorTemplate_Bottlebooks_Event
        exhibitor(exhibitorId: $exhibitorId) {
          exhibitorPackage: customFieldValue(key: "exhibitorPackage") {
            ... on Bottlebooks_SelectFieldValue {
              key
            }
          }
        }
        registrations(filter: { companyId: { eq: $exhibitorId } }) {
          nodes {
            ...vv_PavilionPage_Registration
            ...vv_exhibitorPackage
            ...vv_BrandOwner
            ...vv_BrandWinemaker
            registeredProducts {
              nodes {
                productId
                product {
                  ...vv_ProductName
                  ...vv_ProductVarieties
                }
                pricing {
                  price
                }
              }
            }
          }
        }
      }
    }

    exhibitor(id: { eq: $id }) {
      ...ExhibitorTemplate_Exhibitor
      ...vv_PavilionPage
    }
    previous: exhibitor(id: { eq: $previousId }) {
      ...ChangeExhibitorLink
    }
    next: exhibitor(id: { eq: $nextId }) {
      ...ChangeExhibitorLink
    }
    ...ExhibitorTemplate_Query
  }
`;

function afterQuery(data) {
  const bbExhibitor = data?.bottlebooks?.event?.exhibitor;
  return {
    ...data,
    bottlebooks: {
      ...data?.bottlebooks,
      event: {
        ...data?.bottlebooks?.event,
        exhibitor: wipePremiumData({
          ...bbExhibitor,
          products: {
            ...bbExhibitor?.products,
            nodes: bbExhibitor?.products?.nodes?.map((node) => ({
              ...node,
              pricing: addPriceRange(node.pricing),
            })),
          },
        }),
        registrations: {
          ...data?.bottlebooks?.event?.registrations,
          nodes: data?.bottlebooks?.event?.registrations?.nodes?.map(
            (registration) =>
              wipePremiumData({
                ...registration,
                registeredProducts: {
                  ...registration?.registeredProducts,
                  nodes: registration?.registeredProducts?.nodes?.map(
                    (node) => ({
                      ...node,
                      pricing: addPriceRange(node?.pricing),
                    })
                  ),
                },
              })
          ),
        },
      },
    },
  };
}

function wipePremiumData(exhibitor) {
  if (process.env.NODE_ENV === 'development') console.log(exhibitor);
  const exhibitorPackage = exhibitor.exhibitorPackage?.key;
  if (exhibitorPackage === 'premium' || exhibitorPackage === 'pavilion') {
    return exhibitor;
  }
  const { onlineShop, onlineShopUrl, videos, galleryImages, ...rest } =
    exhibitor;
  return rest;
}
